import { Navigate, Route, Routes } from "react-router-dom";
import CreateStockShipmentPage from "./CreateStockShipmentPage";
import StockShipmentDetailPage from "./StockShipmentDetailPage";
import StockShipmentsPage from "./StockShipmentsPage";

const StockShipmentRoutes = () => {
  return (
    <Routes>
      <Route index element={<StockShipmentsPage />} />
      <Route path="new" element={<CreateStockShipmentPage />} />
      <Route path=":shipmentId" element={<StockShipmentDetailPage />} />
      <Route path="*" element={<Navigate to="/sales/inventory" replace />} />
    </Routes>
  );
};

export default StockShipmentRoutes;
